export default __webpack_public_path__ + "static/frame2-b3855307b95f6aa724fad37a864b9c89.jpg";